<div class="row pt-2">
    <p-steps [model]="steps" [(activeIndex)]="activeStep" class="col-12" />
</div>
<div [class]="'row pt-3 wizard-content ' + (contentClass() ?? '')">
    <ng-content />
</div>